import Header from "@/components/Header";
import Footer from "@/components/Footer";
import FloatingActions from "@/components/FloatingActions";
import useSEO from "@/hooks/useSEO";
import Hero from "@/components/sections/Hero";
import Stats from "@/components/sections/Stats";
import About from "@/components/sections/About";
import Services from "@/components/sections/Services";
import WhyChoose from "@/components/sections/WhyChoose";
import Process from "@/components/sections/Process";
import Industries from "@/components/sections/Industries";
import Infrastructure from "@/components/sections/Infrastructure";
import Quality from "@/components/sections/Quality";
import Products from "@/components/sections/Products";
import Sustainability from "@/components/sections/Sustainability";
import Testimonials from "@/components/sections/Testimonials";
import FAQ from "@/components/sections/FAQ";
import Contact from "@/components/sections/Contact";

export default function Home() {
  useSEO({
    title: "Agroya Refinery LLP · Gold & Silver Refining in Pune, India",
    description:
      "Agroya Refinery LLP — Pune-based precious metals refiner. Gold & silver refining, recovery, assaying and bullion manufacturing (99.90 / 99.50 purity). NABL, BIS, MSME registered.",
    canonical: "https://agroya1935.com/",
  });
  return (
    <div data-testid="home-page">
      <Header />
      <main>
        <Hero />
        <Stats />
        <About />
        <Services />
        <WhyChoose />
        <Process />
        <Industries />
        <Infrastructure />
        <Quality />
        <Products />
        <Sustainability />
        <Testimonials />
        <FAQ />
        <Contact />
      </main>
      <Footer />
      <FloatingActions />
    </div>
  );
}
